module.exports = __webpack_public_path__ + "static/media/LOGO.4956bdbb.svg";